import React from 'react';
import Script from 'next/script';
import PropTypes from 'prop-types';

const VoiceFlow = ({ property }) => {
  const versionID = process.env.ENV === 'prod' ? 'production' : 'development';

  return (
    <Script type="text/javascript">
      {`
        (function(d, t) {
          var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
          v.onload = function() {
            window.voiceflow.chat.load({
              verify: { projectID: '66abbd67f34d75b35b5dfba0' },
              url: 'https://general-runtime.voiceflow.com',
              versionID: "${versionID}",
              launch: {
                event: {
                  type: "launch",
                  payload: {
                    property: "${property?.id}"
                  }
                }
              }
            });
          }
          v.src = "https://cdn.voiceflow.com/widget/bundle.mjs";
          v.type = "text/javascript";
          s.parentNode.insertBefore(v, s);
        })(document, 'script')
      `}
    </Script>
  );
};

VoiceFlow.propTypes = {
  property: PropTypes.object.isRequired
};

export default VoiceFlow;
